import { useCallback, useSyncExternalStore } from 'react'

import { type ConfigName } from '../domain/Config'
import { useRemoteConfig } from './ConfigProvider'

export function useConfig(config: ConfigName) {
  const { adapter, ready } = useRemoteConfig()

  const subscribe = useCallback(
    (listener: () => void) => adapter.subscribe('update', listener),
    [adapter]
  )

  return useSyncExternalStore(subscribe, () => ready && adapter.getConfig(config))
}
